var _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardViewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1000",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard11",
    x: 0,
    y: 0,
    width: 1000,
    height: 1000
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18863,0,0,1.58085,534.854,-249.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.64,202.878C676.64,178.063 652.172,157.916 622.035,157.916L112.903,157.916C71.579,157.916 29.211,191.995 29.211,227.273C29.211,745.526 29.211,706.831 29.211,726.179C29.211,761.456 76.054,790.489 111.785,790.489L622.035,790.489C652.172,790.489 676.64,770.342 676.64,745.526L676.64,202.878ZM113.342,233.5L113.342,725.42L579.923,725.42L579.923,233.5L113.342,233.5Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.18863,0,0,1.58085,465.146,-249.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.64,202.878C676.64,178.063 652.172,157.916 622.035,157.916L112.903,157.916C71.579,157.916 29.211,191.995 29.211,227.273C29.211,745.526 29.211,706.831 29.211,726.179C29.211,761.456 76.054,790.489 111.785,790.489L622.035,790.489C652.172,790.489 676.64,770.342 676.64,745.526L676.64,202.878ZM113.342,233.5L113.342,725.42L579.923,725.42L579.923,233.5L113.342,233.5Z",
    style: {
      fill: "white"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardViewIcon);
export default __webpack_public_path__ + "static/media/card-view-icon.916f80affc430649d205ab8e61ebe009.svg";
export { ForwardRef as ReactComponent };